import {GlobalAnalyticsVariablesInterface} from '../interfaces';
import {AnalyticsTelemetryErrorData} from '../../shared/interfaces';
import {retrieveMergeResponseGlobalVarsCase} from './retrieve-merge-response-global-vars.case';

export const trackBackendErrorPayloadCase = (
  payload: AnalyticsTelemetryErrorData,
  globalVariables?: GlobalAnalyticsVariablesInterface,
) => retrieveMergeResponseGlobalVarsCase(
  true,
  payload,
  globalVariables
);
